import PropTypes from 'prop-types';
import React from 'react';
import Popup from 'reactjs-popup';

const modalContentStyle = {
  "textAlign": "left",
  "border": "none",
  "borderRadius": "8px",
  "boxShadow": "var(--sl-shadow-lg)",
  "background": "var(--sl-bg-primary)",
  "color": "var(--sl-text-primary)",
  "width": "640px",
  "maxWidth": "95%",
  "padding": "0px"
};

const categoryLabel = (category) => {
  if (!category) {
    return "Uncategorized";
  }

  if (category === "uncategorized_file") {
    return "Other";
  }

  return category
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

const SubmittedEvidenceModal = ({ team, paymentDispute }) => {
  const fileUrl = (paymentDisputeUpload) =>
    `/teams/${team.id}/payment_dispute_uploads/${paymentDisputeUpload.id}`;

  return (
    <Popup modal
            contentStyle={modalContentStyle}
            closeOnDocumentClick={true}
            className={"popup-modal"}
            trigger={
              <button type="button"
                      className="btn btn-setlist-secondary btn-block">
                <strong>View Submitted Response</strong>
              </button>
            }>
      {close => (
        <div className="popup-modal-container">
          <div className="row m-0"
                style={{
                  "padding": "16px 7px",
                  "borderBottom": "2px solid var(--sl-border-primary)"
                }}>
            <div className="col d-flex align-items-center">
              <p className="mb-0"
                  style={{"fontSize": "20px"}}>
                <strong>Submitted Response</strong>
                {paymentDispute.human_submitted_at ? (
                  <span className="ml-2"
                        style={{"fontSize": "14px", "color": "var(--sl-text-tertiary)"}}>
                    {paymentDispute.human_submitted_at}
                  </span>
                ) : null}
              </p>
            </div>
            <div className="col d-flex align-items-center justify-content-end">
              <a href="#"
                  onClick={
                    (e) => {
                      e.preventDefault();
                      close();
                    }
                  }
                  style={{"fontSize": "24px", "color": "var(--sl-text-tertiary)"}}>
                <i className="fal fa-times"></i>
              </a>
            </div>
          </div>
          <div className="m-0 px-4 py-3"
                style={{"maxHeight": "70vh", "overflowY": "auto"}}>
            {paymentDispute.uncategorized_text ? (
              <div className="mb-4">
                <p className="mb-1"
                    style={{"fontSize": "14px"}}>
                  <strong>Why should you win this dispute?</strong>
                </p>
                <p className="mb-0 small"
                    style={{"whiteSpace": "pre-wrap"}}>
                  {paymentDispute.uncategorized_text}
                </p>
              </div>
            ) : null}
            {paymentDispute.payment_dispute_uploads.map((paymentDisputeUpload) =>
              <div className="mb-4" key={paymentDisputeUpload.id}>
                <p className="mb-1"
                    style={{"fontSize": "14px"}}>
                  <strong>{categoryLabel(paymentDisputeUpload.category)}</strong>
                  <span className="ml-2 small"
                        style={{"color": "var(--sl-text-tertiary)"}}>
                    {paymentDisputeUpload.file_file_name}
                  </span>
                </p>
                {(paymentDisputeUpload.file_content_type || "").startsWith("image/") ? (
                  <img src={fileUrl(paymentDisputeUpload)}
                        alt={paymentDisputeUpload.file_file_name}
                        style={{
                          "maxWidth": "100%",
                          "border": "1px solid var(--sl-border-primary)",
                          "borderRadius": "8px"
                        }} />
                ) : (
                  <iframe src={fileUrl(paymentDisputeUpload)}
                          sandbox=""
                          title={paymentDisputeUpload.file_file_name}
                          style={{
                            "width": "100%",
                            "height": "420px",
                            "border": "1px solid var(--sl-border-primary)",
                            "borderRadius": "8px"
                          }} />
                )}
              </div>
            )}
          </div>
        </div>
      )}
    </Popup>
  );
};

SubmittedEvidenceModal.propTypes = {
  team: PropTypes.object.isRequired,
  paymentDispute: PropTypes.object.isRequired
};

export default SubmittedEvidenceModal;
